<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = defineProps<{
  redirectUrl: string
  showMessage?: boolean // Zeige Nachricht vor Redirect (optional)
}>()

const countdown = ref(5)
const isRedirecting = ref(false)

const performRedirect = () => {
  isRedirecting.value = true
  window.location.href = props.redirectUrl
}

onMounted(() => {
  // Countdown für verzögerten Redirect
  const interval = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(interval)
      performRedirect()
    }
  }, 1000)
})
</script>

<template>
  <div class="finish-redirect has-text-centered">
    <div class="hero">
      <div class="hero-body">
        <div class="container">
          <h2 class="title is-3">Vielen Dank!</h2>
          <p class="subtitle is-5">Ihre Antworten wurden erfolgreich übermittelt.</p>

          <div class="content">
            <div v-if="!isRedirecting" class="notification">
              <p>
                Sie werden in <strong>{{ countdown }}</strong> Sekunde{{
                  countdown !== 1 ? 'n' : ''
                }}
                weitergeleitet...
              </p>
              <progress class="progress" :value="5 - countdown" :max="5"></progress>
            </div>
          </div>

          <div class="buttons is-centered mt-4">
            <button
              @click="performRedirect"
              class="button is-primary is-medium"
              :class="{ 'is-loading': isRedirecting }"
              :disabled="isRedirecting"
            >
              <span class="icon">
                <i class="fas fa-external-link-alt"></i>
              </span>
              <span>Jetzt weiterleiten</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../../../assets/main.css';

.hero {
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.progress {
  margin-top: 1rem;
}

.notification {
  max-width: 400px;
  margin: 1.5rem auto;
}

.buttons {
  margin-top: 2rem;
}

.button.is-medium {
  padding: 1rem 2rem;
}

@media (max-width: 768px) {
  .title.is-3 {
    font-size: 1.5rem;
  }

  .subtitle.is-5 {
    font-size: 1.1rem;
  }

  .button.is-medium {
    padding: 0.75rem 1.5rem;
  }
}
</style>
